<template>
  <page class="page fill-height">
    <v-row
        justify="center"
        align="center"
    >
      <v-col cols="12" class="text-center">
        <v-img
            class="mx-auto"
            src="/img/clapLabB.png"
            :max-width="maxLogoWidth"
        />
        <way-clap-btn />
      </v-col>
    </v-row>
    <v-row
        justify="center"
        align="center">
      <div class="select-lang-container">
        <lang-select />
      </div>
    </v-row>

    <v-footer
        app
        color="transparent"
    >
      <div class="text-center mx-auto d-flex flex-row align-center mb-5 mb-sm-0 pointer" @click="goToClapSite">
        <div class="site-link text-subtitle-1 text-sm-h6 pt-12">לאתר</div>
        <v-img
            class="mx-auto mr-n3"
            src="/img/clapLabB.png"
            :max-width="maxFooterLogoWidth"
        />
      </div>
    </v-footer>
  </page>
</template>

<script>

import WayClapBtn from "../../components/WayClapBtn";
import LangSelect from "src/components/LangSelect";

export default {
  name: "LoginClapwayView",
  components: { LangSelect, WayClapBtn },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    maxLogoWidth() {
      switch (this.breakpoint) {
        case "xs":
          return 250;
        case "sm":
          return 300;
        case "md":
          return 350;
        default:
          return 400;
      }
    },
    maxFooterLogoWidth() {
      switch (this.breakpoint) {
        case "xs":
          return 120;
        case "sm":
          return 140;
        case "md":
          return 160;
        default:
          return 160;
      }
    }
  },
  methods: {
    goToClapSite() {
      window.location.href = "http://site.clap-lab.com/";
    }
  }

};
</script>

<style scoped>

.site-link {
  color: #ED217C;
}

.v-application .text-subtitle-1, .v-application .text-sm-h6 {
  font-family: Assistant, sans-serif !important;
  font-style: normal;
  font-weight: bold;
}

.pointer {
  cursor: pointer;
}
.select-lang-container {
  max-width: 250px;
}
</style>
